import * as React from 'react';
import { AutoComplete } from '../../containers/autocomplete/AutoComplete';
import { AUTOCOMPLETE_SUGGESTION_RENDER } from '../../models/utilities/type-models';
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';

// #region Component Props

interface IProps {
    id                  : string;
    label               : string;
    value               : any;
    onChange            : any;
    dispatch            : any;
    className?          : string;
    error?              : string;
    disable?            : boolean;
    endpoint            : string;
    placeholder         : string;
    suggestionRender?   : AUTOCOMPLETE_SUGGESTION_RENDER;
}

// #endregion

const AutoCompleteInput : React.SFC<IProps> = (props) => {

    const { 
        className, 
        id, 
        error, 
        label, 
        value, 
        onChange, 
        disable, 
        dispatch,
        endpoint,
        placeholder,
        suggestionRender
    } = props;

    return (
        <div className={'form-group ' + (className)}>
            <InputLabel htmlFor={id} error={error}>
                {label}
            </InputLabel>
            <AutoComplete
                id={ id }
                dispatch={ dispatch }
                classList={ error ? 'error-outline' : '' }
                onSelectedCallback={ onChange }
                currentValue={ value ? (value.name ? value.name : value) : '' }
                disabled={ disable ? disable : false }
                endpoint={ endpoint }
                suggestionRender={ suggestionRender }
                placeholder={ placeholder }
            />           
            <InputFeedback error={error} />
        </div>
    );
};

AutoCompleteInput.defaultProps = {
    className: '',
    error: '',
    disable: false,
    suggestionRender: 'default'
};

export { AutoCompleteInput };
